import {AppBar, Toolbar, Typography, Box, useTheme} from "@mui/material";
import React, { useState } from "react";
import {useNavigate} from "react-router-dom";
import {RegistrationDialog} from "../RegistrationDialog/RegistrationDialog";
import {LoginDialog} from "../LoginDialog/LoginDialog";
import {LoginComponent} from "../LoginComponent/LoginComponent";
import {useAuth} from "../../../AuthContext/authContext";
import useIsTablet from "../../../hooks/utilHooks/useIsMobile/useIsTablet";
import useIsMobile from "../../../hooks/utilHooks/useIsMobile/useIsMobile";

export const NavBar = () => {

    const navigate = useNavigate();
    const isTablet = useIsTablet();
    const isMobile = useIsMobile();
    const [isRegistrationDialogOpen, setIsRegistrationDialogOpen] = useState(false);
    const [isLoginDialogOpen, setIsLoginDialogOpen] = useState(false);
    const theme = useTheme()

    return (
        <AppBar
            position="static"
            sx={{ width: '100%', background: theme.palette.info.dark}}
        >
            <Toolbar>
                <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ width: '100%' }}
                >

                    <Typography
                        variant="h6"
                        component="div"
                        sx={{ flexGrow: 1, cursor: 'pointer' }}
                        onClick={() => navigate(`/`)}
                    >
                        trend-spotting
                    </Typography>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: "flex-end",
                            width: { xs: '32.5%', sm: '27.5%', md: '22.5%', lg: '17.5%'},
                            alignItems: 'center',
                            gap: { xs: '8px', sm: '0' },
                        }}
                    >
                        <LoginComponent
                            setIsLoginDialogOpen={setIsLoginDialogOpen}
                            setIsRegistrationDialogOpen={setIsRegistrationDialogOpen}
                        />
                    </Box>
                </Box>
                <RegistrationDialog
                    isOpen={isRegistrationDialogOpen}
                    onClose={() => setIsRegistrationDialogOpen(false)}
                />
                <LoginDialog
                    isOpen={isLoginDialogOpen}
                    onClose={() => setIsLoginDialogOpen(false)}
                />
            </Toolbar>
        </AppBar>
    );
};
